import { EVENT_CATEGORIES } from '#~/analytics/constants/index.js';
import {
  SCREEN_ROOM_IDENTITY_PROPERTY,
  type ScreenEventName
} from '#~/analytics/screens/screen-events.js';
import type { AnalyticsTrackFn } from './types.js';

// In-studio screen-view domain tracker (ENG-4324, plan SCR-1). Modeled on
// boot-lifecycle.ts. CRITICAL (per the ticket): the emit goes through the
// canonical `track()` path (the AnalyticsTrackFn wired from useAnalytics), NOT
// pageview's raw posthog.capture — track() runs enrichWithContext, which mints
// the shared context envelope (launch_id, session_id, environment, app_version,
// client). A screen event without that envelope fails the send-boundary receipt.
// There is no dual-write: the generic $pageview keeps firing (not retired here).
// Per rule: reference-rules-in-comments (ai.knowledge/global).

export interface ScreenViewedInput {
  /** Canonical screen name from the IN_STUDIO_SCREEN_EVENTS SSOT (no raw literals). */
  screen: ScreenEventName;
  /** The room the screen belongs to — the "which room" identity Product wants. */
  room_id: string;
}

export const createScreenLifecycleTracker = (track: AnalyticsTrackFn) => ({
  trackScreenViewed: ({ screen, room_id }: ScreenViewedInput): void => {
    // The emitted key comes from the shared constant, not a literal, so the emit,
    // the canonical map's required_properties and the e2e receipt can never name
    // the room differently. The envelope is added by track() -> enrichWithContext.
    track(screen, EVENT_CATEGORIES.SCREEN, { [SCREEN_ROOM_IDENTITY_PROPERTY]: room_id });
  }
});
